import { format } from 'date-fns';

export const formatDate = (date: Date, dateFormat = 'MM/dd/yyyy') => {
  return format(date, dateFormat);
};

export const formatDateTime = (date: Date, dateFormat = 'dd/MM/yyyy HH:mm') => {
  return format(date, dateFormat);
};

export const formatDateTimeUs = (
  date: Date,
  dateFormat = 'MM/dd/yyyy HH:mm OOO'
) => {
  return format(date, dateFormat);
};

export const formatDateStringTimeUs = (
  date: string,
  dateFormat = 'MM/dd/yyyy HH:mm OOO'
) => {
  return formatDateTimeUs(new Date(Date.parse(date)), dateFormat);
};

export const getTimeZone = (date: Date): string => {
  const dateTimeZone = date.toString().match(/\(.*\)/gm);
  if (dateTimeZone?.length && dateTimeZone[0]) {
    return dateTimeZone[0]
      .replace(/\W/gm, ' ')
      .trim()
      .split(' ')
      .map((w) => w[0])
      .join('');
  }
  return '';
};

export const formatDateTimeUsWithTz = (
  date: Date,
  dateFormat = 'MM/dd/yyyy HH:mm'
): string => {
  return `${format(date, dateFormat)} ${getTimeZone(date)}`;
};

export const formatDateStringTimeUsWithTz = (
  date: string,
  dateFormat = 'MM/dd/yyyy HH:mm'
): string => {
  return formatDateTimeUsWithTz(new Date(Date.parse(date)), dateFormat);
};

const formatNumberToTwoDigit = (n: number): string => {
  return n > 9 ? n.toString() : `0${n}`;
};

export const formatDateStringTimeUTC = (inputDate: string): string => {
  const date = new Date(Date.parse(inputDate));
  return `${formatNumberToTwoDigit(
    date.getUTCMonth() + 1
  )}/${formatNumberToTwoDigit(date.getUTCDate())}/${date.getUTCFullYear()}`;
};
